import React from "react";
import PropTypes from "prop-types";
import { FieldSelect } from "@conserveit/blocks";

const formatOptions = (options) =>
  Object.keys(options).map((key) => {
    const option = {
      label:
        key === "group"
          ? `${options[key]} - Contact your administrator for access`
          : options[key],
      value: key,
      isDisabled: key === "group",
    };
    return option;
  });

const GroupTypeForm = ({ onChange, groupTypeOptions, formData }) => {
  const options = formatOptions(groupTypeOptions);

  return (
    <FieldSelect
      className="group_type"
      label="Group Type"
      name="group_type"
      placeholder="Select Group Type.."
      value={options.find((o) => o.value === formData.group_type)}
      onChange={({ value }) => onChange(value, "group_type")}
      options={options}
    />
  );
};

GroupTypeForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  groupType: PropTypes.string,
  groupTypeOptions: PropTypes.object,
  formData: PropTypes.object,
};

GroupTypeForm.defaultProps = {
  groupType: "",
  groupTypeOptions: {},
};

export default GroupTypeForm;
